/**
 * Opciones de jornada compartidas entre features.
 * Los keys corresponden al tipo `Day` (`'D' | 'V'`) del domain compartido.
 */
export const JORNADA_OPTIONS = [
  { key: 'D', label: 'Diurno' },
  { key: 'V', label: 'Vespertino' },
];
